// interface MessageProps {
//   message: ReactNode;
// }

export let SignupFields;
(function (SignupFields) {
  SignupFields["phoneNumber"] = "phoneNumber";
})(SignupFields || (SignupFields = {}));
export let COUNTRY_FILTER_TYPE;

/**
 * Determine which countries will be displayed or blocked in the phone number field
 */
(function (COUNTRY_FILTER_TYPE) {
  COUNTRY_FILTER_TYPE["ALLOWED"] = "allowedCountries";
  COUNTRY_FILTER_TYPE["BLOCKED"] = "blockedCountries";
})(COUNTRY_FILTER_TYPE || (COUNTRY_FILTER_TYPE = {}));